<template lang="pug" src="./instructions.pug"></template>

<script>
import Content from 'custom/custom-instructions-content/custom-instructions-content'
import Hero from 'components/hero/hero'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.instructions
    }
  },
  components: {
    Content,
    Hero
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/instructions/instructions.vue